// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input__Input__2JD9x"};